<!--
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2024-06-11 14:05:15
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2025-09-19 15:26:36
 * @FilePath: \hxt-saas-pc\src\views\MyRights\components\ztxx.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="table">

        <div class="tabAtcive">
            <div :class="progressType == '' ? 'active' : ''" @click="getztjh()">全部</div>
            <div :class="progressType == 1 ? 'active' : ''" @click="getztjh(1)">已完成</div>
            <div :class="progressType == 2 ? 'active' : ''" @click="getztjh(2)">未完成</div>
        </div>
        <div class="zbList ztList-box" v-if="ztlist.length">
            <div @click="toDetails(item)" class="ztList" v-for="item in ztlist" :key="item.specId">
                <div class="ztList_box">
                    <div class="ztList_img">
                        <img style="width: 100%;height: 100%;" :src="item.coverUrl" alt="">
                    </div>
                    <div class="ztList_con">
                        <div class="ztList_con_title">
                            {{ item.name }}
                        </div>
                        <div class="ztList_con_txt"> {{ item.description }}
                        </div>
                        <div class="ztList_con_kc">
                            <div class="ztList_con_li" v-if="item.courseCount">
                                <div>包含课程</div>
                                <div>{{ item.courseCount }}门</div>
                            </div>
                            <div class="ztList_con_li" v-if="item.courseTotalTime">
                                <div>总课程时长</div>
                                <div>{{ item.courseTotalTime }}</div>
                            </div>
                            <div class="ztList_con_li" v-if="item.liveCount">
                                <div>包含直播</div>
                                <div>{{ item.liveCount }}门</div>
                            </div>
                            <div class="ztList_con_li" v-if="item.paperCount">
                                <div>包含考试</div>
                                <div>{{ item.paperCount }}场</div>
                            </div>


                        </div>
                    </div>
                </div>
                <div class="jd">
                    <div class="jdt"> <el-progress :color="customColor"
                            :percentage="item.studyProgress ? item.studyProgress : 0" :show-text='false'></el-progress>
                    </div>
                    <div class="jd_txte">{{ item.studyProgress ? item.studyProgress : 0
                    }}%</div>

                </div>
            </div>
        </div>
        <div class="zbList" v-else>

            <div class="wsj" v-if="progressType == ''">
                <div style="margin: 0 auto;width: 192px;height: 138px;"><img src="../../../assets/img/zwsj.png" alt="">
                </div>
                <div class="zwsj">没有购买的专题, 马上去专题商城挑选吧！</div>
                <br>
                <div class="toSC" @click="toJx">去购买 </div>
            </div>
            <div class="wsj" v-else>
                <div style="margin-top: 180px;">
                    <img style="width: 160px;" src="@/assets/img/nodata.png" alt="">
                    <div style="width: 180px;text-align: center;margin-top: 20px;font-size: 17px;color: #999999">
                        暂无数据 ！
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getMySpecPlanList
} from '@/api/index.js';
export default {
    components: {},
    props: {},
    data() {
        return {
            deptId: '',
            token: '',
            customColor: '#0F6CF5',
            progressType: '',////完成类型（1：已完成 2：未完成）可选 不传递为全部
            ztlist: [],
        }
    },
    computed: {},
    watch: {},
    created() {

        var token = window.localStorage.getItem('token');
        var dept = window.localStorage.getItem('TopDeptId');
        if (token) {


            this.token = token;
        }
        if (dept) {
            this.deptId = dept;
        }
        this.getztjh()
    },


    methods: {
        getztjh(data) {
            this.progressType = data ? data : ""
            getMySpecPlanList({ deptId: this.deptId, progressType: this.progressType, name: "" }, {
                Authorization: this.token,
                DeptId: this.deptId,
            }).then(res => {
                console.log(res)
                this.ztlist = res.rows

            })
        },
        toDetails(row) {
            console.log(111111111, row)
            this.$router.push(`/ztDetails/${row.specId}`)

        }, toJx() {
            window.location.href = "https://hxt.saas.taxchina.com/#/";
        },
    },
}
</script>
<style scoped lang="less">
.table {
    width: 1200px;
    height: auto;

    margin: 0 auto;
}

.tabAtcive {
    display: flex;
    margin-bottom: 10px;

    div {
        width: 66px;
        height: 29px;
        border-radius: 14px;
        line-height: 29px;
        cursor: pointer;
        text-align: center;
        margin-right: 30px;
    }

    .active {
        border: 1px solid #0F6CF5;
        color: #0F6CF5;
    }
}

.zbList {
    width: 100%;
    height: auto;
    display: flex;

    flex-wrap: wrap;
}

.ztList-box {
    justify-content: space-between;
}

.wsj {
    width: auto;
    margin: 0 auto;
}

.zwsj,
.toSC {
    font-size: 20px;
    width: 100%;
    height: 100px;
    line-height: 100px;
    color: #9B9FAA;
    text-align: center;
}

.toSC {
    margin: 0 auto;
    width: 110px;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    height: 34px;
    line-height: 34px;
    background: #0F6CF5;
    border-radius: 48px;
    cursor: pointer;

}

.ztList {
    cursor: pointer;
    width: 590px;
    height: 204px;
    background: linear-gradient(180deg, #F6FAFC 0%, #FAFBFF 100%);
    border: 1px solid rgba(15, 108, 245, 0.2);
    // margin-right: 8px;
    margin-bottom: 20px;

    .ztList_box {
        height: 148px;
        width: 570px;

        margin: 20px auto;
        display: flex;

        .ztList_img {
            width: 126px;
            height: 148px;
            background: #D8D8D8;
            border-radius: 8px;
            margin-right: 10px;
        }

        .ztList_con {
            width: 420px;
            height: 148px;

            .ztList_con_title {
                width: 420px;
                height: 28px;

                font-weight: 500;
                font-size: 20px;
                color: #272828;
                line-height: 28px;
                margin-bottom: 20px;
                white-space: nowrap;
                /* 防止文本换行 */
                overflow: hidden;
                /* 隐藏超出容器的内容 */
                text-overflow: ellipsis;
                /* 用省略号表示被截断的文本 */
            }

            .ztList_con_txt {
                width: 420px;
                height: 40px;

                font-weight: 400;
                font-size: 14px;
                color: #9B9FAA;
                line-height: 20px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                /* 设置最大显示行数 */
                -webkit-box-orient: vertical;
                text-overflow: ellipsis;
                margin-bottom: 10px;
            }

            .ztList_con_kc {
                display: flex;
                //  justify-content: space-between;
                text-align: center;
            }

            .ztList_con_li {
                margin-right: 30px;
            }

            .ztList_con_li>div:last-child {
                font-weight: 500;
                font-size: 22px;
                color: #121212;
            }

            .ztList_con_li>div:first-child {
                font-weight: 400;
                font-size: 14px;
                color: #121212;
            }
        }

    }


    .jd {
        margin-top: 20px;
        display: flex;

        .jdt {
            margin-left: 10px;
            margin-right: 10px;
            width: 90%;
        }

        .jd_txte {
            height: 20px;
            line-height: 20px;
            width: auto;

            margin-top: -10px;
        }
    }
}
</style>